module.exports = __webpack_public_path__ + "img/aef562406978d624533bc4836ee1de39.png";